var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ExchangeSmallWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,5c-7.16174,0 -13,5.83826 -13,13v11.87891l-3.43945,-3.43945c-0.28248,-0.2909 -0.67069,-0.45506 -1.07617,-0.45508c-0.61065,0.00015 -1.16026,0.37042 -1.38978,0.93629c-0.22952,0.56587 -0.09314,1.21439 0.34486,1.63988l5.87109,5.87109c0.28495,0.37156 0.72705,0.58875 1.19529,0.58721c0.46824,-0.00153 0.90891,-0.22161 1.19142,-0.59503l5.86328,-5.86328c0.39185,-0.37623 0.54969,-0.9349 0.41265,-1.46055c-0.13704,-0.52565 -0.54754,-0.93616 -1.07319,-1.07319c-0.52565,-0.13704 -1.08432,0.0208 -1.46055,0.41265l-3.43945,3.43945v-11.87891c0,-5.54026 4.45974,-10 10,-10c2.59565,0 4.93698,0.98895 6.71875,2.60938c0.3932,0.38003 0.96204,0.516 1.4846,0.35486c0.52256,-0.16114 0.91604,-0.59385 1.02693,-1.12932c0.11089,-0.53547 -0.07837,-1.08887 -0.49395,-1.44429c-2.30423,-2.09558 -5.37398,-3.39062 -8.73633,-3.39062zM35.47656,12.97852c-0.46352,0.00746 -0.89755,0.2288 -1.17578,0.59961l-5.86133,5.86133c-0.39185,0.37623 -0.54969,0.9349 -0.41265,1.46055c0.13704,0.52565 0.54754,0.93616 1.07319,1.07319c0.52565,0.13704 1.08432,-0.0208 1.46055,-0.41265l3.43945,-3.43945v11.87891c0,5.54026 -4.45974,10 -10,10c-2.59565,0 -4.93698,-0.98895 -6.71875,-2.60937c-0.3932,-0.38003 -0.96204,-0.516 -1.4846,-0.35486c-0.52256,0.16114 -0.91604,0.59385 -1.02693,1.12932c-0.11089,0.53547 0.07837,1.08887 0.49395,1.44429c2.30423,2.09557 5.37398,3.39063 8.73633,3.39063c7.16174,0 13,-5.83826 13,-13v-11.87891l3.43945,3.43945c0.37623,0.39185 0.9349,0.54969 1.46055,0.41265c0.52565,-0.13704 0.93616,-0.54754 1.07319,-1.07319c0.13704,-0.52565 -0.0208,-1.08432 -0.41265,-1.46055l-5.87109,-5.87109c-0.28814,-0.37752 -0.73802,-0.5963 -1.21289,-0.58984z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ExchangeSmallWhite);
export default __webpack_public_path__ + "static/media/icons8-exchange-small-white.774e18421584a4a74564275df4171080.svg";
export { ForwardRef as ReactComponent };